import BrandProductDescription from './BrandProductNotes';
export default BrandProductDescription;
